import React from 'react';
import { observer } from 'mobx-react-lite';
import { Helmet } from 'react-helmet';
import AdminLayout from './AdminLayout';
const ProductImages = (props) => {
  // console.log('ProductImages', props)
  return (
    <React.Fragment>
      <Helmet>
        <title>Simulcast - Portal</title>
      </Helmet>
      <AdminLayout
        auctionName={props.location.state?.auctionName}
        laneName={props.location.state?.laneName}
        uploadStatus={props.location.state?.uploadStatus}
        AuctionID={props.match.params.auctionID}
        LaneID={props.match.params.laneID}
        MediaState={props.match.params.mediaState}
      />
    </React.Fragment>
  );
};

export default observer(ProductImages);
